<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
window.JQuery = require('jquery')
window.$ = require('jquery')
import '../static/ibcoinexx/js/jquery.min.js'

export default {
		name: 'app',
		created() {
            //this.$store.dispatch(types.RUN_STATE_LOAD)
        },
       
    }
</script>

<style>

@Import '../static/ibcoinexx/css/frontend/bootstrap.min.css';
@Import '../static/ibcoinexx/css/frontend/font-awesome.min.css';
@Import '../static/ibcoinexx/css/frontend/hover-min.css';
@Import '../static/ibcoinexx/css/frontend/flaticons.css';
@Import '../static/ibcoinexx/css/frontend/sidebar-nav.min.css';
@Import '../static/ibcoinexx/css/frontend/blue_css.css';
@Import '../static/ibcoinexx/css/frontend/login/style.css';
@Import '../static/ibcoinexx/css/frontend/custom.css';
@Import '../static/ibcoinexx/css/frontend/style.css';

</style>



// WEBPACK FOOTER //
// src/App.vue